var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TimeSpentByActivityTypeTooltip } from '@web/components/Dashboard/TimeSpentOnWorkActivities/TimeSpentByActivityTypeTooltip';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { PeriodBarChart } from '@web/components/layout/RechartsItems/PeriodBarChart';
import { rechartsDiagonalStripeFillUrl } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig, TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS, TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG, TIME_SPENT_BY_ACTIVITY_TYPE_KEYS } from '@web/config';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, getChartDestinationForActivityType, getEventsLogDestinationForActivityType, navigateChartPeriodBarClick } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { buildTimeSpentByActivityTypeChartData, buildTimeSpentByActivityTypeLegendItems } from '@web/utility/timeSpentOnWorkActivitiesCharts';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { formatDuration } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var activityTypeTeamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.timeSpentByActivityType, "_").concat(dataKey);
};
export var TimeSpentByActivityType = function (_a) {
    var data = _a.data, previousData = _a.previousData, teamAverageByType = _a.teamAverageByType, userId = _a.userId, orgUnitId = _a.orgUnitId, interval = _a.interval, dateFrom = _a.dateFrom, dateTo = _a.dateTo, refetch = _a.refetch, _b = _a.useEventsLogNavigation, useEventsLogNavigation = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var showTeamAverage = userId != null && teamAverageByType != null;
    var chartData = buildTimeSpentByActivityTypeChartData(data.byType, previousData.byType, {
        interval: interval,
        dateFrom: dateFrom,
        dateTo: dateTo,
        teamAverageByType: showTeamAverage ? teamAverageByType : undefined
    });
    var legendItems = buildTimeSpentByActivityTypeLegendItems(data.byType, previousData.byType, showTeamAverage ? teamAverageByType : undefined);
    var metricLabels = TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.reduce(function (acc, key) {
        acc[key] = t("app.dashboard.timeSpentByActivityTypeLegend.".concat(key));
        return acc;
    }, {});
    var seriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(metricLabels);
    var previousStackDataKeys = TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; });
    var currentStackDataKeys = TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; });
    var teamStackDataKeys = TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS.team.map(function (config) { return config.dataKey; });
    var tooltipSeriesOrder = showTeamAverage
        ? __spreadArray(__spreadArray(__spreadArray([], previousStackDataKeys, true), currentStackDataKeys, true), teamStackDataKeys, true) : __spreadArray(__spreadArray([], previousStackDataKeys, true), currentStackDataKeys, true);
    var teamStripePatterns = showTeamAverage
        ? TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.map(function (key) {
            var teamDataKey = "team".concat(key.charAt(0).toUpperCase() + key.slice(1));
            return {
                patternId: activityTypeTeamStripePatternId(teamDataKey),
                chartColor: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].teamChartColor
            };
        })
        : [];
    var stripeSwatchColors = showTeamAverage
        ? Object.fromEntries(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.map(function (key) {
            var teamDataKey = "team".concat(key.charAt(0).toUpperCase() + key.slice(1));
            return [
                teamDataKey,
                TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].teamChartColor
            ];
        }))
        : undefined;
    var exportData = chartData.map(function (row) {
        var _a;
        var entry = (_a = {},
            _a[t('filters.period')] = row.period,
            _a);
        TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.forEach(function (key) {
            var _a, _b, _c;
            var dataKeySuffix = key.charAt(0).toUpperCase() + key.slice(1);
            var label = t("app.dashboard.timeSpentByActivityTypeLegend.".concat(key));
            entry["".concat(t('export.current'), " ").concat(label)] =
                (_a = row["current".concat(dataKeySuffix)]) !== null && _a !== void 0 ? _a : 0;
            entry["".concat(t('export.previous'), " ").concat(label)] =
                (_b = row["previous".concat(dataKeySuffix)]) !== null && _b !== void 0 ? _b : 0;
            if (showTeamAverage) {
                entry["".concat(t('export.teamAverage'), " ").concat(label)] =
                    (_c = row["team".concat(dataKeySuffix)]) !== null && _c !== void 0 ? _c : 0;
            }
        });
        return entry;
    });
    var renderTimeSpentByActivityTypeTooltip = createEdgePositionedBarTooltipContent(showTeamAverage ? (_jsx(TimeSpentByActivityTypeTooltip, { seriesOrder: tooltipSeriesOrder, metricLabels: metricLabels, stripeSwatchColors: stripeSwatchColors, showTeamAverage: showTeamAverage, dateFrom: dateFrom, dateTo: dateTo, t: t })) : (_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: seriesLabelFormatter, formatValue: function (value) { return formatDuration(value, 'hours'); } })), chartData.length);
    var getDestinationForActivityType = useEventsLogNavigation
        ? getEventsLogDestinationForActivityType
        : getChartDestinationForActivityType;
    var handleBarClick = function (activityKey, stack, barData, fallbackIndex) {
        navigateChartPeriodBarClick({
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: stack,
            destination: getDestinationForActivityType(activityKey),
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.dashboard.timeSpentByActivityType'), description: "widgetTitleDescriptions.dashboard.timeSpentByActivityType", insightType: InsightTypeEnum.timeSpentByActivityType, insightsData: __assign({ current: data.byType, previous: previousData.byType }, (showTeamAverage && { teamAverage: teamAverageByType })), refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.dashboard.timeSpentByActivityType'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, exportData];
                    }); }); }, disabled: isAiButtonDisabled(data.byType) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: TIME_SPENT_BY_ACTIVITY_TYPE_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    var chartStacks = __spreadArray([
                        {
                            stackId: 'prev',
                            segments: TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS.previous.map(function (config, index) { return ({
                                dataKey: config.dataKey,
                                fill: config.fill,
                                keyPrefix: "prev-".concat(config.dataKey),
                                hide: !isSeriesVisible(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS[index]),
                                onClick: function (barData, barIndex) {
                                    return handleBarClick(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS[index], ComparisonPeriod.Previous, barData, barIndex);
                                }
                            }); })
                        },
                        {
                            stackId: 'curr',
                            segments: TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS.current.map(function (config, index) { return ({
                                dataKey: config.dataKey,
                                fill: config.fill,
                                keyPrefix: "curr-".concat(config.dataKey),
                                hide: !isSeriesVisible(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS[index]),
                                onClick: function (barData, barIndex) {
                                    return handleBarClick(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS[index], ComparisonPeriod.Current, barData, barIndex);
                                }
                            }); })
                        }
                    ], (showTeamAverage
                        ? [
                            {
                                stackId: 'team',
                                segments: TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS.team.map(function (config, index) { return ({
                                    dataKey: config.dataKey,
                                    fill: rechartsDiagonalStripeFillUrl(activityTypeTeamStripePatternId(config.dataKey)),
                                    keyPrefix: "team-".concat(config.dataKey),
                                    hide: !isSeriesVisible(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS[index])
                                }); })
                            }
                        ]
                        : []), true);
                    return (_jsx(PeriodBarChart, { chartData: chartData, dateFrom: dateFrom, dateTo: dateTo, interval: interval, barsPerGroup: showTeamAverage ? 3 : 2, tooltipContent: renderTimeSpentByActivityTypeTooltip, stripePatterns: teamStripePatterns, yAxisTickFormatter: function (value) { return formatDuration(value, 'hours'); }, legend: _jsx("div", __assign({ className: "flex flex-col flex-wrap justify-start gap-2 lg:flex-row lg:gap-4" }, { children: legendItems.map(function (_a) {
                                var key = _a.key, currentTotal = _a.currentTotal, diffValue = _a.diffValue, teamAverageDiffValue = _a.teamAverageDiffValue;
                                return (_jsx(LegendItem, { color: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].color, label: t("app.dashboard.timeSpentByActivityTypeLegend.".concat(key)), currentValue: formatDuration(currentTotal, 'seconds'), diffValue: diffValue, teamAverage: teamAverageDiffValue, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key));
                            }) })), stacks: chartStacks }));
                } }))] })));
};
